module.exports = __webpack_public_path__ + "static/media/postlight-labs-animation.ebbd3d63.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/postlight-labs-animation.gif
// module id = 688
// module chunks = 0